import {FromFilterDefinition, NonNullableFilterValues, NullableFilterValues,} from "../filtering";

export const LOCATION_FILTER_DEFINITION = {
    search: 'string',
    client: 'string[]',
    city: 'string[]',
    state: 'string[]'
} as const;


export type LocationFilterDefinition = FromFilterDefinition<typeof LOCATION_FILTER_DEFINITION>

export type NullableLocationFilter = NullableFilterValues<LocationFilterDefinition>;
export type NonNullableLocationFilter =
    NonNullableFilterValues<LocationFilterDefinition>;

export const DEFAULT_LOCATION_FILTER: NullableLocationFilter = {
    search: null,
    client: null,
    city: null,
    state: null,
};
